import React from "react";
import { FOOTER } from "@/constants/testIds";

export default function Footer() {
  return (
    <footer
      data-testid={FOOTER.container}
      className="relative pt-20 pb-10 border-t border-border"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-10 items-start">
        <div className="md:col-span-5">
          <div className="max-w-md">
            <h3 className="font-serif text-3xl md:text-5xl leading-[1.05] text-foreground">
              Neha Gupta,
            </h3>
            <p className="mt-3 font-serif text-lg md:text-xl text-foreground/90 leading-snug">
              Psychodynamic Psychotherapist, ISTDP Practitioner
            </p>
          </div>
        </div>
        <div className="md:col-span-3 text-sm text-muted-foreground space-y-2">
          <div className="text-xs uppercase tracking-[0.3em] text-foreground/60">Practice</div>
          <div>Independent Practice</div>
          <div>Panjim, Goa · India</div>
        </div>
        <div className="md:col-span-4 text-sm text-muted-foreground space-y-2">
          <div className="text-xs uppercase tracking-[0.3em] text-foreground/60">For enquiries</div>
          <div>
            Please use the{" "}
            <a href="#contact" className="text-foreground underline-grow">
              appointment form
            </a>
            .
          </div>
          <div className="pt-2">By referral &amp; word of mouth.</div>
        </div>
      </div>
      <div className="mx-auto max-w-7xl px-6 md:px-10 mt-16 pt-6 border-t border-border/60 flex flex-col sm:flex-row justify-between gap-3 text-xs text-muted-foreground">
        <div>&copy; {new Date().getFullYear()} Neha Gupta Psychotherapy. Held in confidence.</div>
        <div className="italic font-serif text-foreground/60">
          &ldquo;We are all different, but we are connected.&rdquo;
        </div>
      </div>
    </footer>
  );
}
